

import React, { useEffect, useState } from "react";
import "./ManageReviewers.css";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { IoHomeOutline } from "react-icons/io5";
import { CgNotes } from "react-icons/cg";
import { GrDocumentSound } from "react-icons/gr";
import { IoIosLink } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";
import {
  superAdminSelector,
  userId,
  superAdminAction,
} from "../../redux/reducers/superAdminReducer";
import ENDPOINT_URL from "../../config";
import AddReviewerModal from "./AddReviewerModal";
import EditReviewerModal from "./EditReviewerModal";
import { HiOutlineUserGroup } from "react-icons/hi";
import { toast } from "react-toastify";
import { IoArrowBack } from "react-icons/io5";
const ManageReviewers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = useSelector(superAdminSelector);
  const getUserId = useSelector(userId);

  const [user, setUser] = useState({ username: "", email: "" });
  const [reviewers, setReviewers] = useState([]);
  // const [pipelines, setPipelines] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [email, setEmail] = useState("");
  const [reviewerName, setReviewerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  // const [selectedPipelines, setSelectedPipelines] = useState([]);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [editReviewerId, setEditReviewerId] = useState(null);

  // ======================= Validate PM =======================
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(
          `${ENDPOINT_URL}/api/programmanagers/me`,
          { withCredentials: true }
        );
        setUser(res.data);
      } catch (err) {
        navigate("/login");
      }
    };

    if (getUserId) {
      if (role === "Program Manager") fetchUser();
      else if (role === "Admin") navigate("/admincards");
      else navigate("/cards");
    } else navigate("/login");
  }, []);

  // ======================= Load Reviewers =======================
const loadReviewers = async () => {
  console.log("API Request: GET /api/reviewers/list");

  try {
    const res = await axios.get(`${ENDPOINT_URL}/api/reviewer/list`, {
      withCredentials: true,
    });

    console.log("API Response (Reviewers List):", res.data);
    setReviewers(res.data || []);
  } catch (err) {
    console.error("API Error (Load Reviewers):", err);
    toast.error(err?.response?.data?.error || "Unable to load reviewers.");
  }
};
  // ======================= Load Pipelines =======================
// const loadPipelines = async () => {
//   console.log("API Request: GET /api/pipelines");

//   try {
//     const res = await axios.get(`${ENDPOINT_URL}/api/pipelines`, {
//       withCredentials: true,
//     });

//     console.log("API Response (Pipelines):", res.data);
//     setPipelines(res.data || []);
//   } catch (err) {
//     console.error("API Error (Load Pipelines):", err);
//     toast.error(err?.response?.data?.error || "Unable to load pipelines.");
//   }
// };

  useEffect(() => {
    loadReviewers();
    // loadPipelines();
  }, []);

  // ======================= Checkbox toggle =======================
  // const togglePipeline = (id) => {
  //   setSelectedPipelines((prev) =>
  //     prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
  //   );
  // };

  // ======================= Add Reviewer =======================
// Email validation (add above your function)
const validateEmail = (email) => {
  if (!email) return false;
  if (!email.includes("@")) return false;
  if (/\s/.test(email)) return false;
  if (email.includes("..")) return false;

  // basic check
  const basicPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!basicPattern.test(email)) return false;

  // advanced pattern
  const advancedPattern =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return advancedPattern.test(email);
};

// MAIN FUNCTION
const handleAddReviewer = async () => {
  setError("");
  setSuccessMsg("");

  if (!reviewerName) return setError("Name is required.");

  if (!email) return setError("Email is required.");
  if (!validateEmail(email)) return setError("Enter a valid email address.");

  // OPTIONAL PHONE VALIDATION
  if (phoneNumber) {
    if (!/^[0-9]+$/.test(phoneNumber)) {
      return setError("Phone number must contain digits only.");
    }
    if (phoneNumber.length > 10) {
      return setError("Phone number cannot be more than 10 digits.");
    }
  }

  // if (selectedPipelines.length === 0)
  //   return setError("Select at least one pipeline.");

  console.log("API Request: POST /api/reviewer/create");

  try {
    // const res = await axios.post(
    //   `${ENDPOINT_URL}/api/reviewers/create`,
    //   {
    //     name: reviewerName,
    //     email,
    //     phone: phoneNumber || null,   // <- optional
    //     pipelineIds: selectedPipelines,
    //   },
    //   { withCredentials: true }
    // );
const res = await axios.post(
  `${ENDPOINT_URL}/api/reviewer/create`,
  {
    name: reviewerName,
    email,
    phone: phoneNumber || null,
    // pipelineIds: selectedPipelines,
    createdBy: user._id          
  },
  { withCredentials: true }
);

    console.log("API Response (Add Reviewer):", res.data);

    setSuccessMsg("Reviewer added successfully.");

    setReviewerName("");
    setEmail("");
    setPhoneNumber("");
    // setSelectedPipelines([]);
    setShowAddModal(false);
    loadReviewers();
  } catch (err) {
    console.error("API Error (Add Reviewer):", err);
    setError("Unable to add reviewer.");
    toast.error(err?.response?.data?.error || "Failed to add reviewer.");
  }
};
// ======================= Update Reviewer =======================
const handleUpdateReviewer = async () => {
  setError("");
  setSuccessMsg("");

  // Validate name
  if (!reviewerName) return setError("Name is required.");

  // Validate email (email cannot be changed)
  if (!email) return setError("Email is required.");

  // Phone is optional
  if (phoneNumber) {
    if (!/^[0-9]+$/.test(phoneNumber)) {
      return setError("Phone number must contain digits only.");
    }
    if (phoneNumber.length > 10) {
      return setError("Phone number cannot be more than 10 digits.");
    }
  }

  // if (selectedPipelines.length === 0)
  //   return setError("Select at least one pipeline.");

  console.log(
    `API Request: PATCH /api/reviewer/update/${editReviewerId}`
  );

  try {
    const res = await axios.patch(
      `${ENDPOINT_URL}/api/reviewer/update/${editReviewerId}`,
      {
        name: reviewerName,         
        phone: phoneNumber || null,  
        // pipelineIds: selectedPipelines,
      },
      { withCredentials: true }
    );

    console.log("API Response (Update Reviewer):", res.data);

    setSuccessMsg("Reviewer updated successfully!");
    setShowEditModal(false);

    // Clear fields
    setReviewerName("");
    setPhoneNumber("");
    // setSelectedPipelines([]);

    loadReviewers();
  } catch (err) {
    console.error("API Error (Update Reviewer):", err);
    setError("Unable to update reviewer.");
    toast.error(err?.response?.data?.error || "Failed to update reviewer.");
  }
};
  // ======================= Deactivate Reviewer =======================
const handleDeactivateReviewer = async (reviewerId) => {
  if (!window.confirm("Are you sure you want to deactivate this reviewer?")) {
    return;
  }
  console.log(
    `API Request: PATCH /api/reviewer/deactivate/${reviewerId}`
  );

  try {
    const res = await axios.patch(
      `${ENDPOINT_URL}/api/reviewer/deactivate/${reviewerId}`,
      {},
      { withCredentials: true }
    );

    console.log("API Response (Deactivate Reviewer):", res.data);
    loadReviewers();
  } catch (err) {
    console.error("API Error (Deactivate Reviewer):", err);
    toast.error(err?.response?.data?.error || "Failed to deactivate reviewer.");
  }
};

const handleReactivateReviewer = async (reviewerId) => {
  if (!window.confirm("Reactivate this reviewer?")) return;

  console.log(
    `API Request: PATCH /api/reviewer/reactivate/${reviewerId}`
  );

  try {
    const res = await axios.patch(
      `${ENDPOINT_URL}/api/reviewer/reactivate/${reviewerId}`,
      {},
      { withCredentials: true }
    );

    console.log("API Response (Reactivate Reviewer):", res.data);
    loadReviewers();
  } catch (err) {
    console.error("API Error (Reactivate Reviewer):", err);
    toast.error(err?.response?.data?.error || "Failed to reactivate reviewer.");
  }
};


  // ======================= Logout =======================
const logout = async () => {
  console.log(
    `API Request: POST /api/logout/programManager/${user._id}`
  );

  try {
    const res = await axios.post(
      `${ENDPOINT_URL}/api/logout/programManager/${user._id}`,
      {},
      { withCredentials: true }
    );

    console.log("API Response (Logout):", res.data);

    dispatch(superAdminAction.logoutUser());
    navigate("/login");
  } catch (err) {
    console.error("API Error (Logout):", err);
    toast.error(err?.response?.data?.error || "Logout failed.");
  }
};

return (
  <div className="dashboard-homepage-managereviewers">
    {/* Sidebar */}
<aside className="sidebar-homepage-managereviewers">
  <div className="logo-container-homepage-managereviewers">
    <div className="logo-homepage-managereviewers">
      <img
        src="/navbar/drishtilogo.jpg"
        alt="Logo"
        className="dristilogo-homepage-managereviewers"
      />
    </div>
  </div>

  <div className="nav-container-homepage-managereviewers">
    <nav className="nav-homepage-managereviewers">
      <ul>
        <li>
          <Link to="/homepage">
            <IoHomeOutline className="nav-icon-homepage-managereviewers" />
            Homepage
          </Link>
        </li>

        <li>
          <Link to="/form">
            <CgNotes className="nav-icon-homepage-managereviewers" />
            Create Query Form
          </Link>
        </li>

        <li>
          <Link to="/cohorts">
            <GrDocumentSound className="nav-icon-homepage-managereviewers" />
            Cohorts
          </Link>
        </li>

        <li>
          <Link to="/pipeline">
            <IoIosLink className="nav-icon-homepage-managereviewers" />
            Pipeline
          </Link>
        </li>

        <li className="active">
          <Link to="/manage-reviewers">
            <HiOutlineUserGroup className="nav-icon-homepage-managereviewers" />
            Manage Reviewers
          </Link>
        </li>
        <li className="active">
          <Link to="/program-manager-reviewed-application">
            <HiOutlineUserGroup className="nav-icon-homepage-managereviewers" />
            Reviewed Applications
          </Link>
        </li>
      </ul>
    </nav>
  </div>
</aside>

{/* Header (Replica of Pipeline.jsx) */}
<header className="header-homepage-managereviewers">
  <span className="founder-homepage-managereviewers">
    Manage Reviewers
  </span>

  <div className="profile-section-homepage-managereviewers">
    <div className="user-info-homepage-managereviewers">
      <span className="user-initials-homepage-managereviewers">
        <img src="/navbar/login.png" alt="Login" style={{ width: "40px" }} />
      </span>

      <div className="user-details-homepage-managereviewers">
        <span className="user-name-homepage-managereviewers">
          {user.username}
        </span>
        <br />
        <span className="user-email-homepage-managereviewers">
          {user.email}
        </span>
      </div>
    </div>

    <button
      className="logout-button-homepage-managereviewers"
      onClick={logout}
      style={{ marginLeft: "20px", padding: "8px" }}
    >
      Logout
    </button>
  </div>
</header>
    {/* Main section */}
    <main className="main-content-homepage-managereviewers">

      {/* Reviewers Table */}
      <section className="content-homepage-managereviewers">
        <div
          className="reviewer-header-managereviewers"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <h3 style={{ margin: 0 }}>Reviewers</h3>
          {/* <button
            className="add-new-button-managereviewers1"
            onClick={() => setShowAddModal(true)}
          >
            Add Reviewer
          </button> */}
          {/* START CHANGE: Add Reviewer + Back to Pipelines */}
<div style={{ display: "flex", gap: "10px" }}>
  <button
    className="action-btn-managereviewers"
    onClick={() => setShowAddModal(true)}
  >
    Add Reviewer
  </button>

  <button
    className="action-btn-managereviewers"
    onClick={() => navigate("/pipeline")}
    style={{ display: "flex", alignItems: "center", gap: "6px" }}
  >
    <IoArrowBack size={18} />
    Back to Pipelines
  </button>
</div>


{/* END CHANGE */}
        </div>

        {/* Table Wrapper */}
        <div className="table-wrapper-managereviewers">
          <table className="reviewer-table-managereviewers">
  <thead>
    <tr>
<th>Email</th>
{/* <th>Pipelines</th> */}
<th style={{ textAlign: "center" }}>Action</th>

    </tr>
  </thead>

  <tbody>
    {reviewers.length === 0 ? (
      <tr>
        <td className="no-data-managereviewers" colSpan="3">
          No reviewers added yet
        </td>
      </tr>
    ) : (
      reviewers.map((r, i) => (
        <tr key={i}>
          <td>{r.email}</td>

          {/* <td>
            {(r.pipelines || []).map((p) => (
              <span
                key={p._id}
                className="pipeline-chip-managereviewers"
              >
                {p.title}
              </span>
            ))}
          </td> */}
{/* START CHANGE: Edit + Deactivate + Reactivate */}
<td style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
  {/* If reviewer is active → show Edit + Deactivate */}
  {r.active ? (
    <>
      <button
        className="edit-button-managereviewers"
        onClick={() => {
          setEditReviewerId(r._id);
          setReviewerName(r.name || "");    
          setPhoneNumber(r.phone || "");    
          setEmail(r.email);
          // setSelectedPipelines(r.pipelines.map(p => p._id));
          setError("");
          setSuccessMsg("");
          setShowEditModal(true);
        }}
      >
        Edit
      </button>

      <button
        className="deactivate-button-managereviewers"
        onClick={() => handleDeactivateReviewer(r._id)}
      >
        Deactivate
      </button>
    </>
  ) : (
    /* If inactive → show Reactivate */
    <button
      className="reactivate-button-managereviewers"
      onClick={() => handleReactivateReviewer(r._id)}
    >
      Reactivate
    </button>
  )}
</td>
{/* END CHANGE */}
        </tr>
      ))
    )}
  </tbody>
</table>

        </div>
      </section>
    </main>

{/* Add Reviewer Modal */}
{showAddModal && (
  <AddReviewerModal
    reviewerName={reviewerName}        
    setReviewerName={setReviewerName} 
    phoneNumber={phoneNumber}            
    setPhoneNumber={setPhoneNumber} 
    email={email}
    setEmail={setEmail}
    // pipelines={pipelines}
    // selectedPipelines={selectedPipelines}
    // togglePipeline={togglePipeline}
    error={error}
    successMsg={successMsg}
    onClose={() => setShowAddModal(false)}
    onSave={handleAddReviewer}
  />
)}
{showEditModal && (
  <EditReviewerModal
    reviewerName={reviewerName}
    setReviewerName={setReviewerName}
    phoneNumber={phoneNumber}
    setPhoneNumber={setPhoneNumber}
    email={email}
    setEmail={setEmail}
    // pipelines={pipelines}
    // selectedPipelines={selectedPipelines}
    // togglePipeline={togglePipeline}
    error={error}
    successMsg={successMsg}
    onClose={() => setShowEditModal(false)}
    onUpdate={handleUpdateReviewer}
  />
)}
  </div>
);

};

export default ManageReviewers;

